__turbopack_context__.v({
  "calculator_cta": "styles-module-scss-module__O_rOUq__calculator_cta",
  "condensed": "styles-module-scss-module__O_rOUq__condensed",
  "cta_wrapper": "styles-module-scss-module__O_rOUq__cta_wrapper",
  "price_amount": "styles-module-scss-module__O_rOUq__price_amount",
  "price_display": "styles-module-scss-module__O_rOUq__price_display",
  "price_label": "styles-module-scss-module__O_rOUq__price_label",
  "results_header": "styles-module-scss-module__O_rOUq__results_header",
  "select_wrapper": "styles-module-scss-module__O_rOUq__select_wrapper",
  "stat_item": "styles-module-scss-module__O_rOUq__stat_item",
  "stat_label": "styles-module-scss-module__O_rOUq__stat_label",
  "stat_value": "styles-module-scss-module__O_rOUq__stat_value",
  "stats_grid": "styles-module-scss-module__O_rOUq__stats_grid",
});
